import React, { useState, useEffect } from 'react';
import { Title } from '../../../../component/title/Title';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import useModal from '../../../../hooks/useModal';
import FormLabel from '../../../../component/input/FormLabel.component';
import { FormInput } from '../../../../component/input/InputStyle';
import { Grid } from '@material-ui/core';
import GridComponent from '../../../../component/grid/GridComponent.component';
import ButtonFinish from '../../components/buttonFinish/ButtonFinish.component';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { useManagement } from '../../../../context/Management';
import {getAllPlates, getStatusVehicles, postEntranceVehicles, postExitVehicles} from './EntranceExitService.component';
import ModalConfirmation from './components/Modal/ModalConfirmation.component';
import { useSnackbar } from '../../../../context/Snackbar';
import { Obs, Plate, SuggestionContainer } from './EntranceExit.styles';

const Loadscomponent = () => {
    const {valueCd} = useManagement();
    const [open, addModal] = useModal();
    const { setSnackbar } = useSnackbar();
    const [mensage, setMensage] = useState('');
    const [plate, setPlate] = useState([]);
    const [plateMatch, setPlateMatch] = useState([]);
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState<'entrance' | 'exit'>();

    const confirmationModal = async () => {
        if (type === 'exit') {
            const data = {
                veiculo: text
            }
            try {
                // console.log('saiu')
                const res = await postExitVehicles(data);
                if (res) {
                    addModal(!open);
                    setLoading(false);
                    setSnackbar({msg: 'Gravado saída do veículo com sucesso.', type: 'success'})
                    setText('');
                }
            } catch(error) {
                setLoading(false);
                setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível gravar.' , type: 'error'})
                setText('');
                console.log(error)
            }
        } else {
            const data = {
                veiculo: text
            }
            try {
                // console.log('entrou')
                const res = await postEntranceVehicles(data);
                if (res) {
                    addModal(!open);
                    setLoading(false);
                    setSnackbar({msg: 'Gravado entrada do veículo com sucesso.', type: 'success'})
                    setText('');
                }
            } catch(error) {
                addModal(!open);
                setLoading(false);
                setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível gravar.' , type: 'error'})
                setText('');
                console.log(error)
            }
        }
    }

    const closeModal = () => {
        addModal(!open);
        setLoading(false);
    }

    const allPlates = async () => {
        try {
            const {data} = await getAllPlates(`${valueCd}`)
            // console.log(data)
            setPlate(data)
        } catch(error) {
            console.log(error);
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível mostrar as placas.' , type: 'error'})
        }
    }

    const handleChangeEntrance = (value: string) => {
        let matches = []
        if (value) {
            matches = plate.filter((item: any) => {
                const regex = new RegExp(`${value}`, "gi");
                return item.placa.match(regex);
            })
            setPlateMatch(matches)
        } else {
            setPlateMatch([])
        }
        setText(value)
    }

    const handleClick = (item: string) => {
        // console.log('a',item)
        setText(item)
        setPlateMatch([])
    }

    const handleClickSave = async () => {
        try {
            // console.log(text)
            setLoading(true);
            const {data} = await getStatusVehicles(text);
            // console.log(data[0].status)
            if (data[0].status === 1 || data[0].status === 2 || data[0].status === 3) {
                setType('exit');
                setMensage('Deseja gravar a saída do veículo?');
                addModal(!open);
            } else {
                setType('entrance');
                setMensage('Deseja gravar a entrada do veículo?');
                addModal(!open);
            }
        } catch(error) {
            setLoading(false);
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Confira se a placa existe.' , type: 'error'})
            console.log(error);
        }
    }

    useEffect(() => {
        allPlates();
    }, []);


    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio"/>
            {/* {console.log(plateMatch)} */}
            <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Controle de Entrada e Saída de Veículos</Title>
            <GridComponent justify="flex-end" direction='row' spacing={4}>
                <Obs>Digite a placa<AiOutlineArrowRight size={20}/>Clique em Gravar<AiOutlineArrowRight size={20}/>Confirme entrada ou saída do veiculo.</Obs>
            </GridComponent>
            <Grid item xs={12} sm={12} md={12}>
                <GridComponent justify="center" direction='row' spacing={2}>
                    <FormLabel title="Placa" margin='0px 25px 0px 0px' sm={5} md={5} lg={3} >
                        <FormInput name="placa" value={text} onChange={(e: { target: { value: any; }; }) => handleChangeEntrance(e.target.value)} onBlur={() => {setTimeout(() => {setPlateMatch([])}, 209)
                        }}/>
                        {plateMatch.length > 0 && <SuggestionContainer>{plateMatch.map((item: any, index: number) => (
                            <Plate key={index} onClick={() => handleClick(item.placa)}>{item.placa}</Plate>
                        ))}</SuggestionContainer>}
                    </FormLabel>
                    {loading ? <ButtonFinish name="gravando" onClick={handleClickSave} margin disabled>Gravando...</ButtonFinish> : <ButtonFinish name="gravar" onClick={handleClickSave} margin>Gravar</ButtonFinish>}
                </GridComponent>
            </Grid>
            <ModalConfirmation open={!!open} title={mensage} onClickSubmit={confirmationModal} handleClick={closeModal}/>
        </>
    )
}

export default Loadscomponent;
